// Quilter specific helpers / reusable functions

import $ from "jquery";
import Cookies from "js-cookie";

import utils from "./utils";
// Import these as necessary in your modules

//// Example usage (to use all in one file):
// import quilterFunctions from '../quilter-functions'
//// Then use as required:
// quilterFunctions.regionSelect(event, targetItemIdentifier, targetRegionUrl)

function toggleModalClasses(targetEl, opening) {
  const bodyEl = document.querySelector("body");
  if (opening) {
    if (targetEl) {
      utils.addClass(targetEl, "is-open");
    }
    if (bodyEl) {
      utils.addClass(bodyEl, "no-scroll");
    }
  } else {
    if (targetEl) {
      utils.removeClass(targetEl, "is-open");
    }
    if (bodyEl) {
      utils.removeClass(bodyEl, "no-scroll");
    }
  }
}

/* istanbul ignore next */
function regionSelect(e: Event, target: string, targetHref: string, newRegionId: string | null = null): void {
  if (e) {
    e.preventDefault();
  }

  const targetEl = document.querySelector(target);
  toggleModalClasses(targetEl, true);

  // Skipping pure JS
  if ($(".js-modal-leave-continue").length) {
    $(".js-modal-leave-continue").click((e: any) => {
      e.preventDefault();
      // If leaving a region triggers a prompt, make sure we set a cookie on continue button
      if (newRegionId) {
        Cookies.set("Region", newRegionId, {
          expires: 365,
          path: "/",
          secure: true,
        });
      }
      window.open(targetHref, "_top");
    });
  }
  openModal(target);
}

/* istanbul ignore next */
function openModal(target: string): void {
  const $target = $(target);
  const $focusableEl = $target.find(".js-modal-focusable");
  const targetEl = document.querySelector(target);
  toggleModalClasses(targetEl, true);

  // Skipping vanilla, $ to the help!
  $target.attr("aria-hidden", "false");
  if ($focusableEl.length) {
    $focusableEl.focus(); // Move the focus to inside the modal as per https://www.w3.org/TR/wai-aria-practices/#dialog_modal
  }

  let event: Event;

  // Due to IE11 support requirements, we check whether Event() exists
  // If not, we are forced to use a legacy implementation for event creation
  if (typeof Event === "function") {
    event = new Event("QuilterModal");
  } else {
    event = document.createEvent("Event");
    event.initEvent("QuilterModal", true, true);
  }

  setTimeout(() => document.dispatchEvent(event), 300);
}

/* istanbul ignore next */
function closeModal(targetModal: string): void {
  const currOpenModal = document.querySelector(targetModal + ".is-open");
  toggleModalClasses(currOpenModal, false);
  $(targetModal).attr("aria-hidden", "true");
  // Remove any temporary data from local storage
  window.localStorage.removeItem("newRoleId");
  window.localStorage.removeItem("newRegionId");
}

export default {
  closeModal,
  openModal,
  regionSelect,
};
